@if (label) {
  <label [class.has-error]="!isValid">{{label}}</label>
}
<div [class.list-horizontal]="listHorizontal">
  <div class="form-input">
    @for (option of options; track option) {
      <div class="form-radio">
        <input class="form-check-input"
          type="radio"
          [(ngModel)]="value"
          [name]="id"
          [value]="option[optionValue]"
          [required]="required"
          [disabled]="disabled"
          [readonly]="readonly"
          [class.has-error]="!isValid">
        <label class="form-check-label" (click)="value = option[optionValue]; inputChange()">
          @if (optionLabelTranslate) {
            {{(option[optionLabel]| trans)}}
          }
          @if (!optionLabelTranslate) {
            {{option[optionLabel]}}
          }
        </label>
      </div>
    }
    @if (!isValid && errorMessage) {
      <div class="form-input-validation">
        <div class="form-input-notes-left">{{(errorMessage | trans)}}</div>
      </div>
    }
  </div>
</div>
